/**
 * Backend boundary: factory and public exports.
 *
 * App code imports from `@/lib/backend`; auth flows share `@/lib/insforge`.
 * Contract: `docs/reference/api.md`.
 */

import { insforgeProvider } from "./insforge-provider";
import type { BackendClient } from "./types";

export function getBackendClient(): BackendClient {
  return insforgeProvider;
}

export type {
  AuthSession,
  AuthUser,
  BackendClient,
  BackendError,
  DataClient,
  FunctionsClient,
  InsertRow,
  QueryBuilder,
  QueryResult,
  Row,
  TableName,
  UpdateRow,
} from "./types";
